<template>
<section id="home" class="flex flex-column text-center">
  <h1 class="mt-5 mb-2">Home</h1>
  <div v-if="!userStore.loaded">
    <p>It happears you're not logged in.</p>
    <p>Please login or register to continue.</p>
    <div class="cta-section w-min flex mx-auto gap-4">
      <Button
        label="Login"
        @click="onGoToLogin"
      />
      <Button
        label="Register"
        @click="onGoToRegister"
      />
    </div>
  </div>
  <div v-else>
    <Button
      label="Log Out"
      @click="userStore.logOutUser"
    />
  </div>
</section>
</template>

<script setup lang="ts">
import { useUserStore } from '../stores/UserStore';
import { useRouter } from 'vue-router';
import Button from 'primevue/button';

const userStore = useUserStore();
const router = useRouter();

function onGoToLogin(){
  router.push('/login');
}

function onGoToRegister(){
  router.push('/register');
}
</script>